<template>
  <div
    class="sku_product sku_product--scroll"
    :class="[params && params.refPage === 1 ? 'popup_sku_product' : '']"
    v-if="skuInfo"
  >
    <section class="product-img">
      <div class="img-container">
        <img v-lazy="mainImg" alt="" @click="showPreview(0)" />
      </div>
      <span class="index">1/6</span>
    </section>
    <section class="product-info" tabindex="0">
      <p
        class="price price--deposit"
        v-if="skuInfo.commoditySkuDiscount.commodityDiscountType == 'deposit' && (!params.isSpot || !isSpot)"
        aria-live="polite"
        tabindex="0"
      >
        <span class="label">定金</span>
        <span class="price--sale">
          <dfn>￥</dfn>
          <i
            class="number fs-72"
            :aria-label="`${skuInfo.commoditySkuDiscount.commoditySkuDiscountDetail.commodityDeposite.depositAmount}元`"
          >
            {{ skuInfo.commoditySkuDiscount.commoditySkuDiscountDetail.commodityDeposite.depositAmount | formatNumber }}
          </i>
        </span>
        <span
          class="price--expand"
          v-if="skuInfo.commoditySkuDiscount.commoditySkuDiscountDetail.commodityDeposite.depositSwellAmount"
          :aria-label="`抵${skuInfo.commoditySkuDiscount.commoditySkuDiscountDetail.commodityDeposite.depositSwellAmount}元`"
        >
          （抵
          <dfn>￥</dfn>
          <i class="number">
            {{ skuInfo.commoditySkuDiscount.commoditySkuDiscountDetail.commodityDeposite.depositSwellAmount }}
          </i>
          ）
        </span>
      </p>
      <p class="price" v-else-if="basePrice <= 0" aria-live="polite">
        <span class="price--text">暂无报价</span>
      </p>
      <div class="price" v-else>
        <div class="estimated" v-if="estimated.isShow">
          <PriceModule type="popup" :params="params" />
        </div>
        <template v-else>
          <span
            :class="{ 'price--sale': true, 'price--sale--small': estimated.isShow }"
            tabindex="0"
            aria-live="polite"
          >
            <dfn aria-hidden="true">￥</dfn>
            <i class="number fs-54" :class="estimated.isShow ? 'fs-54' : 'fs-72'">
              <template v-if="skuInfo.commoditySkuBaseInfo.salePrice === 999999">待发布</template>
              <template v-else>
                <span
                  :aria-label="`${mainPrice > 0 ? mainPrice : totalPrice || skuInfo.commoditySkuBaseInfo.salePrice}${
                    mainDotPrice > 0 && mainPrice > 0 ? `.${mainDotPrice}` : ''
                  }元`"
                >
                  {{ mainPrice > 0 ? mainPrice : totalPrice || skuInfo.commoditySkuBaseInfo.salePrice }}
                </span>
              </template>
            </i>
            <i class="dot" v-if="mainDotPrice > 0 && mainPrice > 0">.{{ mainDotPrice }}</i>
          </span>
          <!-- 划线价，赠品不显示划线价 -->
          <span class="del-price through" v-if="marketPrice > salePrice">
            <span class="symbol">￥</span>
            <span class="number" :aria-label="`原价${marketPrice}元`">{{ marketPrice }}</span>
          </span>
        </template>
      </div>
      <p class="selected" tabindex="0" aria-live="polite">已选：{{ checkedText }}</p>
    </section>

    <!--大图展示-->
    <portal to="image-preview">
      <v-image-preview
        v-if="isShowPreview"
        :show="isShowPreview"
        :images="previewImages"
        :startPosition="current"
        :onClose="onClosePreview"
        :bgStyle="bannerStyle"
        :theme="isDarkColor ? 'black' : 'white'"
        class="image-preview"
        v-backFn="{ show: isShowPreview, closeFn: 'onClosePreview' }"
      />
    </portal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '@/utils'
import clientEnv from '@/utils/clientEnv'
import PriceModule from '../../../price-module'
import { formatNumber } from 'utils/common'
export default {
  name: 'SkuProduct',
  props: {
    spuInfo: Object,
    skuInfo: Object,
    discountType: String,
    source: Number,
    checkedInfo: Object,
    totalPrice: Number,
    number: Number,
    suiteId: [String, Number],
    service: Object,
    fqNum: Number,
    params: Object, // params.isSpot是否定金预售的现货购买
    spotEstimatedPrice: [Object, String] // 现货购买到手价
  },
  data() {
    return {
      isShowPreview: false, // 是否开启大图模式
      current: 0 // 查看大图的索引
    }
  },
  components: {
    PriceModule
  },
  computed: {
    ...mapGetters('detailv3', [
      // 是否是赠品
      'isGift',
      // 渐变色
      'color',
      // 判断深浅色
      'isDarkColor',
      // 图片预览背景色
      'bannerStyle',
      // 是否支持现货购买
      'isSpot',
      'totalAdditionCommodityActivityPrice', //加购商品售价
      'totalAdditionCommoditySalePrice' //加购商品市场价
    ]),
    suite() {
      return this.checkedInfo.currentSuite || {}
    },
    // 正常价格 先取优惠价，没有就取销售价
    basePrice() {
      const commodityDiscountPrice = this.skuInfo?.commoditySkuDiscount?.commodityDiscountPrice
      if (commodityDiscountPrice) return commodityDiscountPrice
      else return this.skuInfo?.commoditySkuBaseInfo?.salePrice
    },
    // 价格整数
    mainPrice() {
      return parseInt(this.salePrice)
    },
    // 价格小数
    mainDotPrice() {
      return (this.salePrice + '').split('.')[1] || ''
    },
    // 销售价
    salePrice() {
      return formatNumber((this.totalPrice || this.skuInfo.salePrice) + this.totalAdditionCommodityActivityPrice)
    },
    // 市场价格
    marketPrice() {
      return formatNumber((this.totalPrice || this.skuInfo.salePrice) + this.totalAdditionCommoditySalePrice)
    },
    // 是否显示到手价
    estimated() {
      let type = 'common' // 到手价类型 普通、白银、黄金
      const couponMemberLevel = this.skuInfo?.commoditySkuDiscount?.commodityEstimated?.couponMemberLevel
      if (couponMemberLevel == 2) type = 'silver'
      else if (couponMemberLevel == 3) type = 'gold'
      let commodityEstimatedPrice = this.skuInfo?.commoditySkuDiscount?.commodityEstimated?.commodityEstimatedPrice
      // 现货到手价
      if (this.params?.isSpot && this.spotEstimatedPrice?.commodityEstimatedPrice) {
        commodityEstimatedPrice = this.spotEstimatedPrice.commodityEstimatedPrice
      }
      return {
        isShow:
          !this.isGift &&
          commodityEstimatedPrice &&
          this.number === 1 &&
          this.suiteId == 0 &&
          Object.keys(this.service).length === 0 &&
          this.fqNum == 0,
        type
      }
    },
    // 主图，如果选中套餐，则显示套餐主图
    mainImg() {
      if (this.suite?.imageInfos?.length) {
        return this.suite.imageInfos[0].bigPic
      } else if (this.skuInfo?.imageInfos?.length) {
        return this.skuInfo.imageInfos[0].bigPic
      } else {
        return ''
      }
    },

    // 当前sku的规格名称组合，形如全网通版 8G+128G 极光幻境
    checkedText() {
      let text = []
      const { name, service, number } = this.checkedInfo

      // 规格名
      text.push(name)

      // 如果有套餐，显示套餐名
      if (this.suite?.name && (this.discountType !== 'group' || this.source == 8)) {
        text.push(this.suite.name)
      }

      // 如果选中了服务，分别加入服务名
      let serviceNames = Object.values(service)
        .map(item => item.name)
        .join(' ')
      text.push(serviceNames)

      // 加入数量
      text.push(number + '件')

      return text.join(' ')
    },

    // 大图预览
    previewImages() {
      if (this.suite?.imageInfos?.length) {
        return this.suite.imageInfos.map(v => v.hdPic)
      } else {
        return this.skuInfo.imageInfos.map(v => v.hdPic)
      }
    }
  },
  methods: {
    // 查看大图
    showPreview(index) {
      this.$emit('clickTrack', '商品主图')
      if (
        app.viewImgs({
          browse: {
            images: this.previewImages,
            imageIndex: index
          },
          gradient: {
            fromColor: this.color.value,
            toColor: this.color.valueExt,
            titleColor: this.isDarkColor ? '#ffffff' : '#000000'
          },
          bigImg: {
            // 是否需要滑动查看详情
            useTip: false
          }
        })
      ) {
        // 查看大图
      } else {
        if (clientEnv.isVivoApp && !clientEnv.isIOSVivoApp) {
          app.toggleTitleBarNew({
            isShow: false
          })
        }

        this.current = index
        this.isShowPreview = true
      }
    },
    // 关闭查看大图
    onClosePreview() {
      this.isShowPreview = false
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
